<template>
  <v-container class="scroll-y" fluid>
    <v-row align="center" justify="center">
      <v-col cols="10" md="10">
        <v-card class="ml-20 mr-20">
          <v-app-bar dark color="#2C3A47">
            <v-btn icon>
              <v-icon>mdi-chip</v-icon>
            </v-btn>
            <v-toolbar-title>Serial Number</v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- ADD SN FORM -->
            <v-dialog v-model="dialog" persistent max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn color="red" v-on="on" outlined="">
                  <v-icon left>add</v-icon> ADD
                </v-btn>
              </template>
              <v-card>
                <v-form
                  @submit.prevent="saveSerialNumber"
                  ref="serialNumberData"
                  lazy-validation
                  enctype="multipart/form-data"
                  autocomplete="off"
                >
                  <v-card-title>
                    <span class="headline">Serial Number</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                           <v-form ref="form" v-model="valid">
                           <v-select
                              :items="customerId"
                              item-value="customerId"
                              :item-text="
                                (customerId) => {
                                  return (
                                    customerId.customerId +
                                    ' - ' +
                                    customerId.customerName
                                  );
                                }
                              "
                              v-model="serialNumberData.customerId"
                              label="Customer ID*"
                              :rules="[(v) => !!v || 'Customer ID is required']"
                            >
                            </v-select>
                            <v-select
                              v-model="serialNumberData.deviceType"
                              :items="deviceType"
                              item-value="deviceType"
                              :item-text="
                                (deviceType) => {
                                  return (
                                    deviceType.deviceType +
                                    ' - ' +
                                    deviceType.deviceName
                                  );
                                }
                              "
                              label="Device Type*"
                              :rules="[(v) => !!v || 'Device type is required']"
                            >
                            </v-select>
                            <v-text-field
                              label="Device ID*"
                              type="number"
                              v-model="serialNumberData.serialNumber"
                              :rules="serialNumberRules"
                            ></v-text-field>
                             <v-text-field
                              label="Increment(optional)"
                              type="number"
                              v-model="increment"
                              min="0"
                              v-if="editedIndex <=-1"
                              style="width:180px;"
                              @input="addDevice()"
                            ></v-text-field>  
                            <v-select
                              :items="connectivityType"
                              v-model="serialNumberData.connectivityType"
                              label="Connectivity Type*"
                              :rules="[
                                (v) => !!v || 'Connectivity type is required',
                              ]"
                            >
                            </v-select>    
                           </v-form>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#2C3A47" dark @click="close" outlined small>
                      <v-icon left>exit_to_app</v-icon> Close
                    </v-btn>
                    <v-btn
                      color="light-green darken-4"
                      dark
                      type="submit"
                      outlined
                      small
                    >
                      <v-icon left>save</v-icon> {{ saveDialog }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <!-- END ADD SN FORM -->

          </v-app-bar>
          <v-container>
            <v-card class="mx-auto elevation-19">
              <v-card-title>
                <v-row>
                  <v-col cols="12" md="3" sm="6">
                    <v-row v-if="customerId.length > 0" class="pa-6 pt-2">
                      <v-select
                        :items="customerId"
                        item-value="customerId"
                        :item-text="(customerId) => {
                          return (
                            `${customerId.customerId} - ${customerId.customerName}`
                          );
                        }"
                        v-model="custId"
                        label="Customer ID"
                      ></v-select>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-row v-if="deviceType.length > 0" class="pa-6 pt-2">
                      <v-select
                        :items="deviceType"
                        item-value="deviceType"
                        :item-text="(deviceType) => {
                          return (
                            `${deviceType.deviceType} - ${deviceType.deviceName}`
                          );
                        }"
                        v-model="devType"
                        label="Device Type"
                      ></v-select>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="4" sm="9">
                    <v-row class="pa-6 pt-2">
                      <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        color="#2C3A47"
                      >
                      </v-text-field>
                    </v-row>
                  </v-col>
                  <v-col cols="6" md="2" sm="3">
                    <v-row class="pa-6">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        @click="resetFilter"
                        outlined
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="serialNumber"
                :search="search"
                :custom-filter="updateFilter"
              >
                <template v-slot:[`item.updatedAt`]="{ item }">
                  {{ formatDate(item.updatedAt) }}
                </template>
                <template
                  v-if="$keycloak.realmAccess.roles[0] === 'admin'"
                  v-slot:[`item.actions`]="{ item }"
                >
                  <v-btn
                    color="success"
                    class="mx-2"
                    fab
                    x-small
                    @click="editSerialNumber(item)"
                    outlined
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    color="pink"
                    fab
                    x-small
                    @click="deleteSerialNumber(item._id)"
                    outlined
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <template v-slot:no-results>
                  <v-alert :value="true" color="pink" icon="warning" dark>
                    Your Search {{ search }} does not exist.
                  </v-alert>
                </template>
              </v-data-table>
            </v-card>
          </v-container>
        </v-card>
        <v-snackbar v-model="snackbar" top right :color="color">
          {{ text }}
          <v-btn color="black" text @click="snackbar = false"> Dissmiss </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  props: {
    source: String,
  },
  data: () => ({
    mini: false,
    dialog: false,
    fab: false,
    search: "",
    custId: "", // for filtering
    devType: "", // for filtering
    snackbar: false,
    text: "",
    color: "",
    // checkbox: false,
    serialNumber: [],
    customerId: [],
    deviceType: [],
    increment: 0,
    connectivityType: ["Cellular", "WiFi", "BLE"],
    serialNumberRules: [
      (v) => !!v || "Device ID is required",
      (v) => v.length <= 5 || "Device ID needs to be 5 digits",
      (v) => v.length >= 5 || "Device ID needs to be 5 digits",
    ],
    imeiNumberRules: [(v) => !!v || "IMEI Number/MAC Address is required"],
    serialNumberData: [{
      serialNumber: "",
      customerId: "",
      deviceType: "",
      connectivityType: "",
      connectivityNumber: "",
      modifiedBy: ""
    }],
    default: [{
      serialNumber: "",
      customerId: "",
      deviceType: "",
      connectivityType: "",
      connectivityNumber: "",
      modifiedBy: ""
    }],
    editedIndex: -1,
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
    custId() {
      this.updateFilter();
    },
    devType() {
      this.updateFilter();
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "Device Serial Number",
          value: "serialNumber",
          sortable: true,
          // filter: this.updateFilter
        },
        {
          text: "Connectivity Type",
          value: "connectivityType",
          sortable: true
        },
        {
          text: "IMEI Number/MAC Address",
          value: "connectivityNumber",
          sortable: true
        },
        {
          text: "Modified By",
          value: "modifiedBy",
          sortable: true
        },
        {
          text: "Last Modified Date",
          value: "updatedAt",
          sortable: true
        },
        {
          text: "Action",
          value: "actions",
          sortable: false,
          width: "180px"
        }
      ];
    },
    saveDialog() {
      return this.editedIndex === -1 ? "Save" : "Edit";
    }
  },
  mounted() {
    this.loadsSerialNumber();
    this.loadsCustomerId();
    this.loadsDeviceType();
  },
  methods: {
    addDevice() {
      if(parseInt(this.increment) > 1) {
        const minus = (parseInt(this.increment) - 1);

        for (let i = 0; i < minus; i++) {
          this.serialNumberData.push({ serialNumber:this.serialNumberData.serialNumber });
        }
      } else {
        this.serialNumberData.splice(1);
      }
    },
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a");
    },
    loadsSerialNumber: async function () {
      let apiURL = process.env.VUE_APP_API + "/api/serial-number";
      axios
        .get(apiURL)
        .then((res) => {
          this.serialNumber = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    loadsCustomerId: async function () {
      let apiURL = process.env.VUE_APP_API + "/api/customer-id";
      axios
        .get(apiURL)
        .then((res) => {
          this.customerId = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    loadsDeviceType: async function () {
      let apiURL = process.env.VUE_APP_API + "/api/device-type";
      axios
        .get(apiURL)
        .then((res) => {
          this.deviceType = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {        
        // Reset serialNumberData
        this.serialNumberData = this.default;
        this.editedIndex = -1;
      }, 300);
    },
    saveSerialNumber: async function () {
      if (this.editedIndex > -1) {
        this.updateSerialNumber();
      } else {
        for (var i = 0; i < this.serialNumberData.length; i++) {
          this.createSerialNumber();
        }
      }
    },
    createSerialNumber() {
      if (this.$refs.form.validate()) {
        let apiURL = process.env.VUE_APP_API + "/api/create-serial-number";
        axios
          .post(apiURL, {
            serialNumber: this.serialNumberData.customerId +
            this.serialNumberData.deviceType + ("00000"+ (this.serialNumberData.serialNumber++)).substr(-5),
            connectivityType: this.serialNumberData.connectivityType,
            connectivityNumber: this.serialNumberData.connectivityNumber,
            modifiedBy: this.$keycloak.tokenParsed.given_name
          })
          .then(() => {
            this.close();
            this.loadsSerialNumber();
            this.color = "success";
            this.text = "Serial Number has been successfully saved.";
            this.snackbar = true;
          })
          .catch((error) => {
            console.error(error);

            // Validation errors
            if(error.response.status === 422) {
              const errorMsgs = error.response.data.errors;
              this.color = "error";
              this.text = (errorMsgs.length > 1 ? errorMsgs.join(", ") : errorMsgs.join(""));
              this.snackbar = true;
            }
          });
      }
    },
    editSerialNumber(item) {
      this.editedIndex = this.serialNumber.indexOf(item);
      this.serialNumberData = Object.assign([{}], item);
      this.dialog = true;
    },
    updateSerialNumber() {
      if (this.$refs.form.validate()) {
        let apiURL = process.env.VUE_APP_API + `/api/update-serial-number/${this.serialNumberData._id}`;
        axios
          .post(apiURL, {
            serialNumber: this.serialNumberData.customerId +
            this.serialNumberData.deviceType + ("00000"+ (this.serialNumberData.serialNumber++)).substr(-5),
            connectivityType: this.serialNumberData.connectivityType,
            connectivityNumber: this.serialNumberData.connectivityNumber,
            modifiedBy: this.$keycloak.tokenParsed.given_name
          })
          .then((res) => {
            console.log(res);
            this.close();
            this.loadsSerialNumber();
            this.color = "info";
            this.text = "Serial Number has been modified.";
            this.snackbar = true;
          })
          .catch((error) => {
            console.error(error);
            console.log(this.$route.params.id);

            // Validation errors
            if (error.response.status === 422) {
              const errorMsgs = error.response.data.errors;
              this.color = "error";
              this.text = (errorMsgs.length > 1 ? errorMsgs.join(", ") : errorMsgs.join(""));
              this.snackbar = true;
            }
          });
      }
    },
    deleteSerialNumber(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to go back",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00b894",
        cancelButtonColor: "#d63031",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        // Send request to the server
        if (result.value) {
          try {
            let apiURL = process.env.VUE_APP_API + `/api/delete-serial-number/${id}`;
            let indexOfArrayItem = this.serialNumber.findIndex(
              (i) => i._id === id
            );
            axios
              .delete(apiURL)
              .then(() => {
                this.serialNumber.splice(indexOfArrayItem, 1);
              })
              .catch((error) => {
                console.error(error);
              });
            this.$swal(
              "Deleted!",
              "Serial Number has been deleted.",
              "success"
            );
            //Notification error
            this.color = "error";
            this.text = "Serial Number has been deleted.";
            this.snackbar = true;
            //Notification error
          } catch (error) {
            this.$swal("Failed!", "There was something wrong.", "warning");
          }
        }
      });
    },
    updateFilter(value, query) {
      // Update search
      if (this.custId.length > 0 && this.devType.length > 0) {
        const strToFilter = `${this.custId}${this.devType}`;
        this.search = strToFilter;
      } else if (this.custId.length > 0 && !this.devType) {
        this.search = this.custId;
      } else if (!this.custId && this.devType.length > 0) {
        this.search = this.devType;
      }

      // Return result
      if(value !== undefined && value !== null) {
        if (this.custId.length > 0 && this.devType.length > 0) {
          const strToFilter = `${this.custId}${this.devType}`;
          return value.toLowerCase().startsWith(strToFilter, 0);
        } else if (this.custId.length > 0 && !this.devType) {
          return value.toLowerCase().startsWith(this.custId, 0);
        } else if (!this.custId && this.devType.length > 0) {
          return value.toLowerCase().startsWith(this.devType, 2);
        } else {
          return value.toLowerCase().includes(query.toLowerCase());
        }
      }
    },
    resetFilter() {
      this.custId = "";
      this.devType = "";
      this.search = "";
    }
  },
};
</script>